export const formatExtNo = extNo => {
  if (!extNo) return '';

  // ambil huruf depan + angka
  const match = String(extNo).match(/^([A-Z]+)(\d+)$/i);

  if (!match) return String(extNo);

  const prefix = match[1];
  const numbers = match[2];

  // ambil 4 digit terakhir
  const lastDigits = numbers.slice(-4);

  return `${prefix}${lastDigits}`;
};
